module.exports = __webpack_public_path__ + "static/logo-elle-b3bdc2db284cc3924d38f4959cb963e0.jpg";